<template>
  <div
    class=main--text>
    <v-card>
      <v-form action="https://docs.google.com/forms/u/0/d/e/1FAIpQLSdMSCUiXfqZAJm_dROTy7n_9PJ2q0rtOBfLblMGZWRJl8b1Ag/formResponse">
        <v-container
          fluid>
          <v-row>
            <v-col
              class="font-weight-bold">
              無料体験授業お申し込みフォーム
            </v-col>
          </v-row>
          <v-row
            dense>
            <v-col
              cols=12
              md=6>
              <v-text-field
                v-model="parentName"
                label="お名前"
                placeholder="（例）山田 太郎"
                v-validate="'required'"
                data-vv-name="parentName"
                data-vv-as="お名前"
                :error-messages="errors.collect('parentName')"
                />
            </v-col>
          </v-row>
          <v-row
            dense>
            <v-col
              cols=12
              md=6>
              <v-text-field
                v-model="email"
                label="メールアドレス"
                placeholder="（例）example@prosense.jp"
                v-validate="'required|email'"
                data-vv-name="email"
                data-vv-as="メールアドレス"
                :error-messages="errors.collect('email')"
                />
            </v-col>
          </v-row>
          <v-row
            dense>
            <v-col
              cols=12
              md=6>
              <v-text-field
                v-model="studentName"
                label="お子さまのお名前"
                v-validate="'required'"
                placeholder="（例）山田 花子"
                data-vv-name="studentName"
                data-vv-as="お子さまのお名前"
                :error-messages="errors.collect('studentName')"
                />
            </v-col>
          </v-row>
          <v-row
            dense>
            <v-col
              cols=6
              md=2>
              <v-select
                v-model="studentAge"
                label="お子さまのご年齢(半角数字)"
                :items="ageRange()"
                placeholder="ご選択ください"
                v-validate="'requrired|numeric'"
                data-vv-name="studentAge"
                data-vv-as="お子さまのご年齢"
                :error-messages="errors.collect('studentAge')"
                />
            </v-col>
          </v-row>
          <v-row
            dense>
            <v-col
              cols=12>
              <v-textarea
                v-model="opinion"
                label="ご意見・ご質問等"
                outlined/>
            </v-col>
          </v-row>
          <v-row
            justify=center
            dense>
            <v-col
              cols=auto>
              <v-btn
                @click="submit"
                x-large
                rounded
                depressed
                color="primary"
                class="font-weight-bold">
                <span>送信</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      ageRange: () => {
        const ages = new Array()
        for (let i = 6; i <= 18; i++) {
          ages.push(i)
        }
        return ages
      }
    }
  },
  methods: {
    submit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$emit("submit-button-click")
        }
      })
    },
    updateValue(diff) {
      this.$emit("input", { ...this.value, ...diff })
    }
  },
  computed: {
    parentName: {
      get() {
        return this.value.parentName
      },
      set(parentName) {
        this.updateValue({ parentName })
      }
    },
    email: {
      get() {
        return this.value.email
      },
      set(email) {
        this.updateValue({ email })
      }
    },
    studentName: {
      get() {
        return this.value.studentName
      },
      set(studentName) {
        this.updateValue({ studentName })
      }
    },
    studentAge: {
      get() {
        return this.value.studentAge
      },
      set(studentAge) {
        this.updateValue({ studentAge })
      }
    },
    opinion: {
      get() {
        return this.value.opinion
      },
      set(opinion) {
        this.updateValue({ opinion })
      }
    }
  }
}
</script>
